var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustOverview = function SvgTrustOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.973 3 .175.005a3.08 3.08 0 0 1 2.9 2.9l.005.174v6.026c-.65-.125-1.274-.476-1.89-1.118l-.005-.006V7.737H4.894v9.237c0 .613.465 1.117 1.062 1.178l.121.006h6.752a5.558 5.558 0 0 0 1.097 1.895H6.078a3.08 3.08 0 0 1-3.074-2.905L3 16.974V6.079a3.08 3.08 0 0 1 2.904-3.074L6.078 3h10.895Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.526 13.579a2.526 2.526 0 1 0 0-5.053 2.526 2.526 0 0 0 0 5.053Zm-3.79 3.79v-1.264c0-.697.566-1.263 1.264-1.263h3.474c-.057.421-.107 1.516.151 2.526H7.737Z",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.158 12.25c.592.449 1.223.72 1.895.815.186.027.376.04.568.04.183 0 .336.136.371.315l.008.08v2.37c0 2.54-1.244 4.268-3.67 5.11a.364.364 0 0 1-.24 0 6.308 6.308 0 0 1-1.775-.927 4.58 4.58 0 0 1-1.473-1.895c-.252-.603-.392-1.282-.417-2.037l-.004-.252V13.5c0-.218.17-.395.38-.395 1.158 0 2.2-.482 3.142-1.463a.368.368 0 0 1 .536 0c.22.23.447.433.679.609Z",
    fill: "#999"
  })));
};
export default SvgTrustOverview;